import resolveConfig from 'tailwindcss/resolveConfig';
import { TailwindValuesColor } from 'tailwindcss/tailwind-config';
// @ts-ignore-next-line
import * as tailwindConfig from '@/../tailwind.config.js';

const fullConfig = resolveConfig(tailwindConfig);

type extendColors = {
    primary: {
        300: string;
        500: string;
        700: string;
        800: string;
    };
    pigs: string;
    deaths: string;
    // Narrowed for the same reason as the scales below: a bare colour is typed as the same opaque
    // value a group is, so it cannot be passed anywhere a string is wanted.
    white: string;
    // Scales the charts read tokens from. Tailwind's own `TailwindValuesColor` types a group as an
    // opaque value rather than an indexable record, so a scale has to be declared here before
    // `colors.slate[300]` is anything but an implicit any.
    gray: {
        100: string;
        200: string;
        400: string;
        500: string;
        700: string;
        900: string;
    };
    slate: {
        200: string;
        300: string;
        400: string;
        500: string;
        600: string;
        900: string;
    };
    sky: {
        700: string;
    };
    red: {
        400: string;
        600: string;
    };
    green: {
        700: string;
    };
    blue: {
        600: string;
    };
    purple: {
        600: string;
    };
    amber: {
        600: string;
    };
    teal: {
        600: string;
    };
    pink: {
        600: string;
    };
    indigo: {
        600: string;
    };
    orange: {
        600: string;
    };
    cyan: {
        700: string;
    };
    error: {
        50: string;
        100: string;
        300: string;
        700: string;
        800: string;
    };
    chart: {
        insertion: string;
        transfer: string;
        sold: string;
        death: string;
        slaughters: string;
        slaughtersDiscarded: string;
        weight: string;
        dailyGain: string;
        growthIndex: string;
        water: string;
        note: string;
        noteFill: string;
        noteText: string;
        productionGroupBand: string;
        productionGroupBandBorder: string;
        productionGroupBandText: string;
        cameras: string[];
        feedDeliveries: string[];
        treatments: string;
        treatmentsByDrug: string[];
    };
    feed: {
        400: string;
        600: string;
    };
    slaughters: string;
    status: string;
    transfer: string;
    batch: string;
    'dark-gray': {
        100: string;
        200: string;
        600: string;
        800: string;
    };
    health: string;
};

export default fullConfig.theme.colors as TailwindValuesColor & extendColors;
